import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/audits")({
  component: () => (
    <RouteGuard module="audits"><Outlet /></RouteGuard>
  ),
});
